import React from "react";

const ShiftCard = ({
  title,
  time,
  post,
  duration,
  isSelected,
  onClick,
  canChange = true,
}) => {
  return (
    // Opaque base matching the cell's resting colour so the card's translucent
    // tint renders the same, but the cell's hover colour can't bleed through it.
    <div className="my-0 rounded-md bg-white dark:bg-gray-900" data-shift-card>
      <div
        onClick={onClick}
        className={`w-full max-w-full overflow-hidden rounded-md text-left px-1.5 py-1.5 transition-all duration-150
          ${
            canChange
              ? `bg-brand-50/30 dark:bg-brand-primary/10 cursor-pointer hover:bg-brand-50/50 dark:hover:bg-brand-primary/20 ${
                  isSelected
                    ? "ring-2 ring-brand-primary bg-brand-50/30 dark:bg-brand-primary/10"
                    : "ring-0"
                }`
              : `bg-gray-100 dark:bg-gray-700 cursor-default ${
                  isSelected ? "ring-2 ring-gray-400 dark:ring-gray-500" : "ring-0"
                }`
          }`}
      >
        <div className="w-full max-w-full overflow-hidden flex justify-between h-[35px]">
          <div className="flex-1 min-w-0 flex flex-col justify-center">
            <h3
              className="block truncate whitespace-nowrap overflow-hidden text-sm font-medium text-gray-700 dark:text-gray-200 w-full max-w-full"
              title={title}
            >
              {title}
            </h3>
            <div className="flex items-center text-sms text-gray-500 dark:text-gray-400">
              {time && (
                <p className="pr-1 shrink-0 whitespace-nowrap">{time}</p>
              )}
              {post && (
                <p className="truncate whitespace-nowrap" title={post}>
                  · {post}
                </p>
              )}
            </div>
          </div>
          {duration && (
            <div className="flex items-center justify-center ml-2">
              <span className="text-xs text-gray-400 dark:text-gray-500">{duration}min</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export { ShiftCard };
